export default __webpack_public_path__ + "static/media/service8.55de180e.jpg";